/**
 * Device detection utilities
 */

/**
 * Detect if the current device is running iOS
 * @returns {boolean} True if iOS device (iPhone, iPad, iPod)
 */
export const isIOS = () => {
  // Check for iOS devices including iPad on iOS 13+
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

/**
 * Detect if the browser is Safari (including iOS Safari)
 * @returns {boolean} True if Safari browser
 */
export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

/**
 * Detect if the device is a mobile device
 * @returns {boolean} True if mobile device
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
         (navigator.maxTouchPoints > 0 && window.matchMedia("(max-width: 768px)").matches);
};

/**
 * Check if the browser supports autoplay
 * This is a heuristic check - actual autoplay may still be blocked
 * @returns {boolean} True if autoplay is likely supported
 */
export const supportsAutoplay = () => {
  // iOS devices generally don't support autoplay without user interaction
  if (isIOS()) {
    return false;
  }
  
  // Check if we're in a secure context (HTTPS)
  if (!window.isSecureContext) {
    return false;
  }
  
  return true;
};

/**
 * Get device type string for logging/debugging
 * @returns {string} Device type description
 */
export const getDeviceType = () => {
  if (isIOS()) {
    if (/iPad/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      return 'iPad';
    }
    if (/iPhone/.test(navigator.userAgent)) {
      return 'iPhone';
    }
    if (/iPod/.test(navigator.userAgent)) {
      return 'iPod';
    }
    return 'iOS Device';
  }
  
  if (/Android/.test(navigator.userAgent)) {
    return 'Android';
  }
  
  if (isMobileDevice()) {
    return 'Mobile Device';
  }
  
  return 'Desktop';
};